import { RootState } from '@/lib/store';
import { SetTournamentQuery } from '@/lib/store/tournaments/actions';
import { Input } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function TournamentsPageContentInput() {
  const { t } = useTranslation('tournaments');
  const dispatch = useDispatch();

  const query: string = useSelector(
    (state: RootState) => state.tournaments.query,
  );

  function handleChangeTournamentsQuery(
    e: React.ChangeEvent<HTMLInputElement>,
  ) {
    dispatch(SetTournamentQuery(e.target.value));
  }

  return (
    <Input
      placeholder={t('tournaments_search_placeholder')}
      value={query}
      onChange={handleChangeTournamentsQuery}
      isContainerColor
      icon="fa-solid fa-search"
    />
  );
}
